import React, { useEffect, useState } from "react";

export default function PhyloTable({ idx_pt, distances }) {
  distances = Object.entries(distances).sort((a, b) => a[1] - b[1]);

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-10">
          <div className="card">
            <table className="table" style={{}}>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>SNP distance</th>
                </tr>
              </thead>
              <tbody>
                {distances.map(([name, value]) => (
                  <tr key={name}>
                    <td style={{ textAlign: "left" }}>{name}</td>
                    <td style={{ textAlign: "center" }}>{value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
